import { gql } from '@apollo/client';

export const CREATE_CONTACT_NOTE = gql`
  mutation CreateContactNote($request: CreateContactNoteRequest!) {
    CreateContactNote(request: $request) {
      id
    }
  }
`;

export const UPDATE_CONTACT_NOTE = gql`
  mutation UpdateContactNote(
    $id: String!
    $request: UpdateContactNoteRequest!
  ) {
    UpdateContactNote(id: $id, request: $request) {
      id
    }
  }
`;

export const DELETE_CONTACT_NOTE = gql`
  mutation DeleteContactNote($id: String!) {
    DeleteContactNote(id: $id)
  }
`;
